import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import App from '../LoggedIn'
import Loading from './../Loading'

import * as AuthActions from '../../ducks/authentication'
import * as accountActions from '../../ducks/account'

class LoggedInContainer extends React.Component {
  componentDidMount() {
    this.props.accountActions.getCurrentAccount()
  }

  render() {
    const {
      children,
      currentAccount,
      currentOrganisation,
      currentLanguage,
      authActions
    } = this.props

    if (!currentAccount || !currentOrganisation) {
      return <Loading />
    }

    return (
      <App
        currentLanguage={currentLanguage}
        currentAccount={currentAccount}
        currentOrganisation={currentOrganisation}
        onLogout={authActions.logout}
      >
        {React.cloneElement(children, {
          currentOrganisationId: currentOrganisation.organisation.id
        })}
      </App>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentAccount: state.account.get('currentAccount'),
    currentOrganisation: state.account.get('currentOrganisation'),
    currentLanguage: state.account.get('currentLanguage')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInContainer)



// WEBPACK FOOTER //
// ./src/components/smart/LoggedInContainer.js